var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconStarUt2Sj39Lpz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE352",
    cx: 256,
    cy: 256,
    r: 246
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB236",
    cx: 256,
    cy: 256,
    r: 200
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFE352",
    points: "256,85.777 306.061,187.211 418,203.477 337,282.433 356.121,393.919 256,341.282  155.878,393.919 175,282.433 94,203.477 205.939,187.211  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconStarUt2Sj39Lpz);
export default __webpack_public_path__ + "static/media/reshot-icon-star-UT2SJ39LPZ.ebced50b98e4258f711d031e85d867c6.svg";
export { ForwardRef as ReactComponent };